// normDefaults.js — EN-12193-Norm-Defaults (Klasse III) an EINER Stelle.
//
// Kundenwunsch (2026-08-13): die drei Prüfwerte Em / Emin-Em / RG sind je
// Projekt editierbar (Wizard Schritt 6). Diese Defaults gelten überall, wo
// nichts editiert wurde, und MÜSSEN zu den Backend-Konstanten passen:
// backend/main.py (_EN12193_*) und optimisation_calculate_light.py (NORM_*).
export const NORM_DEFAULTS = {
  em: 75, // mittlerer Wartungswert Em (lux), "≥"
  uo: 0.5, // Gleichmäßigkeit Emin/Em, "≥"
  rg: 55, // Blendindex RG, "≤"
};

// Effektive Vorgaben eines projectDetails-Objekts: editierte Werte, sonst
// Norm-Default. null/undefined = "nichts editiert".
export const effectiveTargets = (projectDetails = {}) => ({
  em: projectDetails.emTarget ?? NORM_DEFAULTS.em,
  uo: projectDetails.uoTarget ?? NORM_DEFAULTS.uo,
  rg: projectDetails.rgMax ?? NORM_DEFAULTS.rg,
});
